import Gsap from './plugins/animation.gsap';
import Debug from './plugins/debug.addIndicator';
import Velocity from './plugins/animation.velocity';
import JQuery from './plugins/selector.jquery';

export const ScrollMagicPluginGsap = Gsap;
export const ScrollMagicPluginIndicator = Debug;
export const ScrollMagicPluginVelocity = Velocity;
export const ScrollMagicPluginJQuery = JQuery;



//////////////////
// WEBPACK FOOTER
// C:/domains.bak/domains/dd.local/wp-content/themes/dobrodya-theme/node_modules/scrollmagic-plugins/index.js
// module id = 19
// module chunks = 0